import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from "@mui/material/IconButton";
import Tooltip from '@mui/material/Tooltip';
import { type ReactElement } from 'react';
import { useLocalizedStrings } from '../../../localization/LocalizedStringsProvider';

export interface DataGridEditButtonProps {
    id: string;
    onClick: (id: string) => void;
    "aria-label"?: string,
    readOnly?: boolean
}

const DataGridEditButton = ({ id, onClick, readOnly, ...rest }: DataGridEditButtonProps): ReactElement => {
    const strings = useLocalizedStrings();

    if (readOnly) {
        return (
            <Tooltip title={strings.view}>
                <IconButton {...rest} onClick={() => onClick(id.toString())}>
                    <VisibilityIcon color="secondary" />
                </IconButton>
            </Tooltip>
        );
    }
    else {
        return (
            <Tooltip title={strings.edit}>
                <IconButton {...rest} onClick={() => onClick(id.toString())}>
                    <EditIcon color="secondary" />
                </IconButton>
            </Tooltip>
        );
    }
}

export default DataGridEditButton;
